/* eslint-disable no-extend-native */

// Install once at app startup (e.g., import in src/main.tsx)

declare global {
  interface String {
    toTitleCase(opts?: {
      preserveAcronyms?: boolean;
      /** Add to the default acronym set (always merged, never overwrites). */
      acronyms?: Iterable<string>;
      /** Optionally remove specific defaults after merging. */
      excludeAcronyms?: Iterable<string>;
      locale?: string;
    }): string;
  }
}

(function installToTitleCase() {
  if (typeof String.prototype.toTitleCase === "function") return;

  const DEFAULT_ACRONYMS = new Set([
    "ID", "API", "JSON", "XML", "HTTP", "HTTPS", "URL",
    "SQL", "POS", "UUID", "OHIP", "NCR", "GRPC", "GPU"
  ]);

  Object.defineProperty(String.prototype, "toTitleCase", {
    configurable: true,
    enumerable: false,
    writable: true,
    value: function (
      this: string,
      opts: {
        preserveAcronyms?: boolean;
        acronyms?: Iterable<string>;
        excludeAcronyms?: Iterable<string>;
        locale?: string;
      } = {}
    ): string {
      const {
        preserveAcronyms = true,
        acronyms = [],
        excludeAcronyms = [],
        locale,
      } = opts;

      if (!this) return "";

      // Build the final acronym set: defaults + additions - exclusions
      const finalAcronyms = new Set(DEFAULT_ACRONYMS);
      for (const a of acronyms) finalAcronyms.add(String(a).toUpperCase());
      for (const a of excludeAcronyms) finalAcronyms.delete(String(a).toUpperCase());

      // Normalize separators
      let s = this.trim().replace(/[_\-\s]+/g, " ");

      // Insert boundaries
      s = s
        .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2") // JSONData -> JSON Data
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2");    // userID -> user ID

      // Title-case tokens
      const words = s.split(/\s+/).map((w) => {
        if (!w) return w;

        const isAllCaps = /^[A-Z0-9]+$/.test(w);
        const upper = w.toUpperCase();

        if (preserveAcronyms && (isAllCaps || finalAcronyms.has(upper))) {
          return upper;
        }

        return w.charAt(0).toLocaleUpperCase(locale) + w.slice(1).toLocaleLowerCase(locale);
      });

      return words.join(" ");
    },
  });
})();

export {};
